<template>
    <div class="root" v-loading="loading">


        <topmenu></topmenu>




        <!-- content -->

        <div class="container2 theme-showcase">

            <div style="display:flex; margin:22px 0; padding: 0 20px;">
                <div style="display:flex; flex:1; padding: 0;">
                    <div style="font-weight:bold; line-height:40px;">
                        Events:
                    </div>
                    <div style="margin-left: 12px;">
                        <el-select v-model="eventId" size="medium" placeholder="Select" @change="eventChange">
                            <el-option v-for="item in eventList" :key="item.id" :label="item.eventName" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div style="flex:1;">
                    <div style="text-align: center; color:#4a8cef; font-weight: bold; font-size: 24px; line-height:40px;">
                        General Dashboard
                    </div>
                </div>
                <div style="flex:1; display:flex; flex-direction: row-reverse;">
                    <div>
                        <el-date-picker v-model="beginDt" type="date" placeholder="">
                        </el-date-picker>
                    </div>
                    <div style=" line-height:40px; margin:0 8px;">~</div>
                    <div>
                        <el-date-picker v-model="endDt" type="date" placeholder="">
                        </el-date-picker>
                    </div>
                </div>
            </div>




            <div style="display: flex;">
                <div style="flex: 1; padding: 0px;">
                    <div
                        style="border: 1px #4a8cef solid; border-radius: 10px; margin:0 20px 0 30px; border-top: 0px; min-height: 740px;">
                        <div
                            style="text-align: center; font-weight: bold; padding: 20px 0; border-top-left-radius: 10px; border-top-right-radius: 10px; font-size: 22px; color: #fff; background-color: #4a8cef; border: 2px #4a8cef solid; border-top: 3px #4a8cef solid; border-bottom: 3px #4a8cef solid;">
                            Check-in Now
                        </div>
                        <table class="table table-hover  table-striped">
                            <el-table :data="checkinList" style="width: 100%" fit="true"
                                :row-class-name="tableRowClassName">
                                <el-table-column prop="index" label="No." width="89">
                                </el-table-column>
                                <el-table-column prop="name" label="Name" width="160">
                                </el-table-column>
                                <el-table-column prop="time" label="Time" width="160">
                                </el-table-column>
                            </el-table>
                        </table>
                    </div>
                </div>
                <div style="flex: 2;">
                    <div style="margin: 0 20px;">
                        <div style="display: flex;">
                            <div
                                style="border: 1px #ec971f solid; padding: 12px; border-radius: 10px; margin: 0 15px 0 0; flex: 1;">
                                <div style="font-size: 18px; color: #ec971f; line-height: 40px;">Total</div>
                                <div style="font-size: 22px; font-weight: bold;">{{ total }}</div>
                            </div>

                            <div
                                style="border: 1px #ec971f solid; padding: 12px; border-radius: 10px; margin: 0 15px 0 0; flex: 1;">
                                <div style="font-size: 18px; color: #ec971f; line-height: 40px;">Printed badges</div>
                                <div style="font-size: 22px; font-weight: bold;">{{ printed }}</div>
                            </div>

                            <div
                                style="border: 1px #ec971f solid; padding: 12px; border-radius: 10px; margin: 0 0 0 0; flex: 1;">
                                <div style="font-size: 18px; color: #ec971f; line-height: 40px;">Check-in</div>
                                <div style="font-size: 22px; font-weight: bold;">{{ checkin }}</div>
                            </div>

                        </div>
                        <div style="display: flex; margin-top: 20px;">
                            <div
                                style="border-radius: 10px; border: 1px #999 solid; margin: 20px 20px 0px 0px; padding: 14px; min-height: 583px;">
                                <div style="font-size: 16px; font-weight: bold;">Participant categories</div>
                                <div>Top categories</div>
                                <div ref="main" style="width: 313px;height:440px;"></div>
                                <div style="height: 70px;"></div>
                            </div>

                            <div
                                style="border-radius: 10px; border: 1px #999 solid; margin: 20px 0 0px 0; padding: 14px; min-height: 583px;">
                                <div style="font-size: 16px; font-weight: bold;">Countries</div>
                                <div>Top countries</div>
                                <div ref="main2" style="width: 313px;height:440px;"></div>
                            </div>

                        </div>
                    </div>
                </div>
                <div style="flex: 2;">


                    <div>
                        <div
                            style="border-radius: 10px; border:1px #999 solid; padding:15px 20px; margin-left: 20px; margin-right: 30px; min-height: 708px;">

                            <div style="margin: 0 20px;">
                                <div style="font-weight: bold;">Check-in/Printed badges </div>
                            </div>

                            <div>

                                <div ref="main3" style="width: 600px;height:420px;"></div>

                            </div>


                            <div v-for="(item, index) in catePrintedList" :key="index">
                                <div style="display: flex; font-weight: bold; font-size: 14px; padding:0 5px;">
                                    <div style=" flex: 1;">{{ item.cateName }}</div>
                                    <div>{{ item.count }}</div>
                                </div>
                                <div style="margin-bottom: 20px; margin-top: 6px;">
                                    <el-progress :text-inside="true" stroke-width="16"
                                        :percentage="item.progress"></el-progress>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div>


        </div>
        <!-- content -->

    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../home/components/topmenu'
import * as echarts from 'echarts'

export default {
    name: 'catelist',
    data: function () {
        return {
            id: 0,
            eventId: '',
            eventList: [],
            loading: false,
            dialogFormVisible: false,
            total: 0,
            printed: 0,
            checkin: 0,
            beginDt: '',
            endDt: '',
            checkinList: [],
            catePrintedList: [],

        }
    },
    components: {
        topmenu
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 1) {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            }
            return '';
        },

        getEchartData1() {
            const chart = this.$refs.main
            if (chart) {
                const myChart = echarts.init(chart)
                const option = {
                    tooltip: {},
                    legend: [{
                        orient: 'vertical',
                        x: '50%',
                        y: 'bottom',
                        data: this.cateList1
                    }, {
                        orient: 'vertical',
                        x: '15%',
                        y: 'bottom',
                        itemGap: 10,
                        data: this.cateList2
                    }],
                    series: [
                        {
                            type: 'pie',
                            center: ['50%', '35%'],
                            label: {
                                show: false
                            },
                            data: this.cateCountList
                        }
                    ]
                }
                myChart.setOption(option)
                window.addEventListener("resize", function () {
                    myChart.resize()
                })
            }
            this.$on('hook:destroyed', () => {
                window.removeEventListener("resize", function () {
                    myChart.resize();
                });
            })
        },

        getEchartData2() {
            const chart = this.$refs.main2
            if (chart) {
                const myChart = echarts.init(chart)
                const option = {
                    tooltip: {},
                    legend: [{
                        orient: 'vertical',
                        x: '50%',
                        y: 'bottom',
                        data: this.countryList1
                    }, {
                        orient: 'vertical',
                        x: '15%',
                        y: 'bottom',
                        itemGap: 10,
                        data: this.countryList2
                    }],
                    series: [
                        {
                            type: 'pie',
                            center: ['50%', '35%'],
                            label: {
                                show: false
                            },
                            data: this.countryCountList
                        }
                    ]
                }
                myChart.setOption(option)
                window.addEventListener("resize", function () {
                    myChart.resize()
                })
            }
            this.$on('hook:destroyed', () => {
                window.removeEventListener("resize", function () {
                    myChart.resize();
                });
            })
        },

        getEchartData3() {
            const chart = this.$refs.main3
            if (chart) {
                const myChart = echarts.init(chart)
                const option = {
                    xAxis: {
                        data: this.cateList
                    },
                    yAxis: {},
                    series: [
                        {
                            data: this.cateCheckinList,
                            type: 'bar',
                            stack: 'x'
                        }
                    ]
                }
                myChart.setOption(option)
                window.addEventListener("resize", function () {
                    myChart.resize()
                })
            }
            this.$on('hook:destroyed', () => {
                window.removeEventListener("resize", function () {
                    myChart.resize();
                });
            })
        },


        loadData(page) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Visitor/general',
                {
                    eventId: this.eventId,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.total = res.total;
                this.printed = res.printed;
                this.checkin = res.checkin;
                this.checkinList = res.checkinList;
                this.catePrintedList = res.catePrintedList;
                this.cateList = res.cateList;
                this.cateList1 = res.cateList1;
                this.cateList2 = res.cateList2;
                this.cateCheckinList = res.cateCheckinList;
                this.cateCountList = res.cateCountList;

                this.countryList = res.countryList;
                this.countryList1 = res.countryList1;
                this.countryList2 = res.countryList2;
                this.countryCountList = res.countryCountList;

                this.getEchartData1();
                this.getEchartData2();
                this.getEchartData3();

            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadEvent() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/event/getList',
                {
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadEventSucc)
        },
        loadEventSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list && res.list.length > 0) {
                    this.eventList = res.list;
                    console.log(this.eventList);
                    if (this.eventId == '' || this.eventId == 0) {
                        this.eventId = res.list[0].id;
                    }
                    this.loadData();
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },


        eventChange(id) {
            console.log(id);
            localStorage.setItem('eventId',id);
            this.currentPage = 1;
            this.loadData(1);
        },


    },
    mounted() {
        const id = this.$route.query.id;
        console.log(id)
        if (id != undefined && id != '') {

        }

        var eventId = localStorage.getItem('eventId');
        if (eventId != null && eventId != undefined) {
            eventId = parseInt(eventId);
            this.eventId = eventId;
        }

        // this.loadData(1);
        this.loadEvent();
        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.root>>>.topmenuitem:nth-child(3) {
    color: #fff;
    background-color: #080808;
}
</style>



// WEBPACK FOOTER //
// src/pages/general/general.vue